import { createSeatRequestRpc, createSkuRequestRpc } from 'growth-monetization-service-types';
import { sendTrialRequestNotificationRpc } from '../../__generated__/chirp/com/hubspot/personalization/rpc/RequestsRpc';
import { rpcClient } from '../client';
export const sendRequestTrialNotification = ({
  apiName
}) => rpcClient.call(sendTrialRequestNotificationRpc, {
  request: {
    apiName
  }
});
export const sendRequestSKUNotification = ({
  apiName
}) => rpcClient.call(createSkuRequestRpc, {
  data: {
    apiName
  }
});
export const sendRequestSeatNotification = ({
  apiName,
  requestReason,
  requestedSeatType
}) => {
  const data = requestedSeatType ? {
    requestedSeatType
  } : {
    apiName
  };
  return rpcClient.call(createSeatRequestRpc, {
    data: Object.assign({}, data, {
      requestReason,
      staged: false
    }),
    queryParameters: {
      sendAdminNotification: true
    }
  });
};